import React, { useState, useEffect } from 'react'
import PlayIcon from '@material-ui/icons/PlayCircleFilled'
import PauseIcon from '@material-ui/icons/PauseCircleFilled'
import StopIcon from '@material-ui/icons/Stop'
import Lottie from 'react-lottie'
import audioWave from '../audioAnime/audio_anime.json'

export default function AudioComponent({
  audioData,
  isRecording,
  onRecordAlert,
  onAudioControlChange,
  isVideoPlaying,
  contained,
  audioStop,
  handleAudioClose,
  isRecordPlaying,
  isSeqPlay,
  feedPlay
}) {
  const { Width, Height, X, Y, Url, ControlID } = audioData

  const audioPlayer = {
    Url: Url,
    Width: Width,
    Height: Height,
    X: X,
    Y: Y
  }

  const [audio] = useState(new Audio(audioPlayer.Url))
  const [playing, setPlaying] = useState(false)
  const [currentTime, setCurrentTime] = useState(0)
  const [duration, setDuration] = useState(0)

  const toggle = () => {
    if (isRecording || isRecordPlaying) {
      onRecordAlert(true)
    } else {
      if (!isVideoPlaying && !isSeqPlay && !feedPlay) {
        setPlaying(!playing)
      }
    }
  }

  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false))
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false))
    }
  }, [])

  useEffect(() => {
    audio.addEventListener('timeupdate', (e) => {
      setCurrentTime(e.target.currentTime)
      setDuration(e.target.duration)
    })
  }, [])

  useEffect(() => {
    if (currentTime === duration) {
      handleAudioClose(true)
      audio.pause()
      audio.currentTime = 0
      setCurrentTime(0)
      setPlaying(false)
    }
  }, [currentTime])

  function getTime(time) {
    if (!isNaN(time)) {
      return (
        Math.floor(time / 60) + ':' + ('0' + Math.floor(time % 60)).slice(-2)
      )
    }
  }

  useEffect(() => {
    if (isVideoPlaying) {
      if (audio) {
        audio.pause()
        audio.currentTime = 0
        setCurrentTime(0)
        setPlaying(false)
      }
    }
  }, [isVideoPlaying])

  useEffect(() => {
    console.log('audioStop', audioStop)
    if (audioStop || isSeqPlay || feedPlay) {
      if (audio) {
        audio.pause()
        audio.currentTime = 0
        setPlaying(false)
      }
    }
  }, [audioStop, isSeqPlay, feedPlay])

  useEffect(() => {
    if (playing) {
      audio.play()
    } else {
      audio.pause()
    }
    if (!contained) {
      onAudioControlChange(playing, ControlID)
    }
  }, [playing])

  function getTime(time) {
    if (!isNaN(time)) {
      return (
        Math.floor(time / 60) + ':' + ('0' + Math.floor(time % 60)).slice(-2)
      )
    }
  }
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: audioWave,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }
  return (
    <div
      style={{
        height: audioPlayer.Height + '%',
        width: audioPlayer.Width + '%',
        left: audioPlayer.X,
        top: audioPlayer.Y,
        position: 'absolute',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#000000',
        display: 'flex',
        alignItems: 'flex-end',
        zIndex: 5,
        cursor: 'pointer',
        backgroundColor: 'lightblue'
      }}
    >
      <div
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            flex: 1,
            width: '50%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            borderColor: 'black',
            borderWidth: '1px',
            //borderStyle: "solid",
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              width: '100%',
              height: '70%',
              display: 'flex'
            }}
          >
            <Lottie
              options={defaultOptions}
              isStopped={!playing}
              style={{
                width: '100%',
                justifyContent: 'center',
                alignSelf: 'center'
              }}
            />
          </div>
          <div
            style={{
              width: '100%',
              height: '30%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {!playing ? (
              <PlayIcon
                onClick={toggle}
                style={{
                  width: '50px',
                  height: '50px',
                  marginRight: '1%',
                  color: '#F50057',
                  cursor: 'pointer'
                }}
              />
            ) : (
              <PauseIcon
                onClick={toggle}
                style={{
                  width: '50px',
                  height: '50px',
                  marginRight: '1%',
                  color: '#F50057',
                  cursor: 'pointer'
                }}
              />
            )}
            <span
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                marginRight: '1%',
                backgroundColor: '#F50057',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer'
              }}
              onClick={() => {
                if (audio) {
                  audio.pause()
                  audio.currentTime = 0
                  setCurrentTime(0)
                  setPlaying(false)
                  handleAudioClose(true)
                }
              }}
            >
              <StopIcon
                style={{
                  width: '30px',
                  height: '30px',
                  marginRight: '1%',
                  color: 'lightblue'
                }}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
